import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 8,
    paddingTop: 2,
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  wrapper: {
    [theme.breakpoints.down('sm')]: {
      overflowY: 'auto',
      padding: '10px 8px',
      msOverflowStyle: 'none',
      scrollbarWidth: 'none',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
  },
}))
